import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { ShareButtons } from "@/components/site/ShareButtons";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const imgUrl = (id) => `${API}/gallery/${id}/image`;

const SPANS = ["md:col-span-7 md:row-span-2", "md:col-span-5", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export const WorkGallery = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    axios.get(`${API}/gallery?category=work`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section id="gallery" className="py-16 sm:py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <p className="eyebrow mb-3">Our work</p>
        <h2 className="font-display mb-10 text-3xl font-bold tracking-tight sm:text-4xl">Built in the desert, built to last.</h2>
        <div className="grid auto-rows-[240px] grid-cols-1 gap-4 md:grid-cols-12">
          {items.map((i, idx) => (
            <figure key={i.id} data-testid={`gallery-item-${i.id}`} className={`group relative overflow-hidden rounded-xl bg-[#EDF0F5] ${SPANS[idx % SPANS.length]}`}>
              <img src={imgUrl(i.id)} alt={i.title} loading="lazy" onClick={() => setOpen(i)} className="h-full w-full cursor-zoom-in object-cover transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute inset-x-3 bottom-3 flex items-center justify-between gap-2">
                {i.title && <span className="rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-[#0E1F3F] backdrop-blur">{i.title}</span>}
                <ShareButtons item={i} />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-4xl p-2" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          {open && <img src={imgUrl(open.id)} alt={open.title} className="max-h-[80vh] w-full rounded-md object-contain" />}
          {open?.caption && <p className="px-2 pb-2 text-sm text-[#5C5850]">{open.caption}</p>}
        </DialogContent>
      </Dialog>
    </section>
  );
};
